import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function About() {
    return (
        <Container className="mb-5">
            <Row>
                <Col>
                    <h1 className="fs-4 fw-bold mb-4">О КОМПАНИИ</h1>
                    <p>ГРУППА КОМПАНИЙ «ЭВОСЕМЬ» МЕНЕЕ 10 ЛЕТ НА РЫНКЕ КЛИМАТИЧЕСКОГО ОБОРУДОВАНИЯ — ЭТО ФАКТ. ЕЩЁ ОДИН ФАКТ — МЫ №1 В РОССИИ ПО ПРОДАЖАМ СПЛИТ-СИСТЕМ НА OZON.
                        Ежемесячный оборот компании в среднем составляет 50 млн. рублей, а представленная линейка техники насчитывает более 500 моделей сплит-систем и 3х десятков брендов, включая такие, как Centek, Newtek, Haier, HEC, Funai, Ballu, Electrolux, Kentatsu, Midea, Gree, Fujitsu, Berlingtoun, Daichi, Green, Hisense, Hitachi, Oasis, Royal Clima и другие.
                        ОБЩАЯ ПЛОЩАД СКЛАДОВ КОМПАНИИ СОСТАВЛЯЕТ БОЛЕЕ 2000м2.</p>
                    <p>СОБСТВЕННАЯ CRM-СИСТЕМА УЧЕТА И ДВИЖЕНИЯ ТОВАРА ОТ ЗАКАЗА ДО ДОСТАВКИ ТЕХНИКИ КЛИЕНТУ.</p>
                    <p>БОЛЕЕ 10 РЕГИОНОВ ПРИСУТСТВИЯ АВТОРИЗОВАННЫХ МОНТАЖНЫХ БРИГАД ПО СТРАНЕ.</p>
                    <p>И лучшая команда специалистов и единомышленников на одной территории.</p>
                    <p>ЭВОСЕМЬ — это группа компаний, объединившаяся с целью предоставить на рынке товаров и услуг только качественную климатическую технику, с принципиально новым подходом в центре которого стоит – клиент.</p>
                    <p>Мы не предлагаем дешевые или дорогие кондиционеры, мы подберем сплит максимально отвечающий вашим потребностям!</p>
                    <p>Группа компаний ЭВОСЕМЬ — это не слияние ради выгоды, скорее коллаборация, для достижения максимального эффекта от использования опыта и компетенций каждого сотрудника, мы не стали ломать внутренние процессы каждой из компаний в группе, мы решаем как отдельные задачи, так и комплексные, используя проверенные методы, практики и пути достижения цели, в основе которых, абсолютная вера, делать бизнес комфортным и доступным.</p>
                    <p>ЮРИДИЧЕСКАЯ ИНОФРМАЦИЯ<br/>
                        Индивидуальный предприниматель<br/>
                        Галич Александр Сергеевич<br/>
                        Юридический адрес: 403010, Волгоградская обл., Городищенский район, рп. Ерзовка, ул. Солнечная, д.6<br/>
                        ИНН 344212182709<br/>
                        ОГРНИП 315344300014164<br/>
                        Расчетный счет 40802810909500022915<br/>
                        Банк: ООО "Банк Точка"<br/>
                        БИК 044525104<br/>
                        Кор./счет 30101810745374525104</p>
                </Col>
            </Row>
        </Container>
    );
}

export default About;